import passwordService from 'ApiService/Admin/passwordService';
import UpdateUserPasswordList from 'pages/List/UpdateUserPasswordList';

const AccountantList = () => {
  const columns = [
    { header: 'Name', key: 'name' },
    { header: 'Email', key: 'email' },
    { header: 'Contact No', key: 'contact' },
    { header: 'Branch', key: 'branchName' },
    { header: 'Location', key: 'branchLocation' },
    { header: 'Role', key: 'role' },
  ];
  const fetchPasswordResetRequests = async (userId, page) => {
    return await passwordService.getAllPasswordResetRequests(userId, page);
  };

  const updatePasswordResetRequests = async (data) => {
    console.log(data, 'data');
    return await passwordService.updatePasswordResetRequests(data);
  };

  return (
    <UpdateUserPasswordList
      fetchUsers={fetchPasswordResetRequests}
      updateUserPassword={updatePasswordResetRequests}
      userType="All Users"
      columns={columns}
    />
  );
};

export default AccountantList;
